import store from "@/store";

export default {
  created() {
    store.dispatch('breadcrumbs/setBreadcrumbs', [
      {displayName: 'マイページ', path: {name: 'MypageTop', params: ''}},
      {displayName: 'オペレーター', path: {name: 'OperatorTop', params: ''}},
      {displayName: '完了案件一覧', path: {name: 'RetrievingMatchings', params: ''}},
    ])
  },
}